import styled from '@emotion/styled';

const Container = styled('div')({
  padding: '1rem 0 1.5rem',
});

export default Container;
